module.exports = __webpack_public_path__ + "main/assets/public/on-air-banner/background-lines.e510f3e548a6bb50.png";